export default (id) => {
    let url
    switch(id) {
        case 1 :
            url = '/img/Fusium_icon.svg'
            break;
            
        case 2 :
            url = '/img/Actium_icon.svg'
            break;
            
        case 3 :
            url = '/img/Minium_icon.svg'
            break;
            
        case 4 :
            url = '/img/Constructium_icon.svg'
            break; 
            
        case 5 :
            url = '/img/wax_logo.svg'
            break;
            
        case 164 :
            url = '/img/wax_logo.svg'
            break;
    }
    return url
}